/**
 * localStorage that never throws. Reading `window.localStorage` can raise a SecurityError
 * (blocked site data, some embedded or private contexts) and `setItem` raises when the quota
 * is full, so each call reports whether it worked instead.
 */

export interface StorageLike {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

export interface StoredRead {
  /** False when the browser refused access to storage. */
  available: boolean;
  value: string | null;
}

function browserStorage(): StorageLike {
  return window.localStorage;
}

export function readStored(
  key: string,
  getStorage: () => StorageLike = browserStorage
): StoredRead {
  try {
    return { available: true, value: getStorage().getItem(key) };
  } catch {
    return { available: false, value: null };
  }
}

/** Returns true when the value was stored. */
export function writeStored(
  key: string,
  value: string,
  getStorage: () => StorageLike = browserStorage
): boolean {
  try {
    getStorage().setItem(key, value);
    return true;
  } catch {
    return false;
  }
}
